'use client';
import { isNumber, isBoolean } from '@s7/utils';

/**
 * typeof value === "string" - 'небезопасный' примитив:
 * при определении собственного сериализатора вы можете вернуть строку,
 * которая совпадёт с названием аргумента мемоизируемой функции.
 * */ const isMemoSafePrimitive = (value)=>{
    return value == null || isNumber(value) || isBoolean(value);
};

export { isMemoSafePrimitive };
//# sourceMappingURL=isMemoSafePrimitive.js.map
